import { z } from 'zod';
import { VeriskEDIEventSchema, veriskEdiServiceEventType } from './service.js';
export const VeriskEDIExportEventSchema = VeriskEDIEventSchema.merge(z.object({
    type: veriskEdiServiceEventType('export'),
    export: z.unknown(),
}));
// #endregion processing
